<div class="h-full w-full flex flex-col items-center justify-center">
  <div class="flex flex-col">
    <h1 class="text-2xl">Available Landings</h1>
    <ul class="inline-flex gap-2 flex-wrap">
      <li><a pButton class="p-button-gpl p-button-s" routerLink="/gpl">GazPromLeasing Landing</a></li>
      <li><a pButton class="p-button-secondary p-button-s" routerLink="/test">Test Landing</a></li>
    </ul>
  </div>

<!--  <div class="flex flex-col gap-2 mt-4 p-4 justify-center items-center bg-white rounded">-->
<!--    <button pButton class="p-button-s">Тест</button>-->
<!--&lt;!&ndash;    <button pButton class="p-button-s" [loading]="true">Тест</button>&ndash;&gt;-->
<!--    <button pButton class="p-button-text">Тест текст</button>-->
<!--&lt;!&ndash;    <button pButton class="p-button-s" [loading]="true">Тест</button>&ndash;&gt;-->
<!--    <button pButton class="p-button-secondary p-button-s">Тест</button>-->
<!--&lt;!&ndash;    <button pButton class="p-button-secondary p-button-s" [loading]="true">Тест</button>&ndash;&gt;-->
<!--    <button pButton class="p-button-tetriary p-button-s">Тест</button>-->
<!--&lt;!&ndash;    <button pButton class="p-button-tetriary p-button-s" [loading]="true">Тест</button>&ndash;&gt;-->
<!--    <button pButton class="p-button-gpl p-button-s">Тест</button>-->
<!--&lt;!&ndash;    <button pButton class="p-button-gpl p-button-s" [loading]="true">Тест</button>&ndash;&gt;-->
<!--    <button pButton class="p-button-gpl p-button-gpl-secondary p-button-s">Тест</button>-->
<!--&lt;!&ndash;    <button pButton class="p-button-gpl p-button-gpl-secondary p-button-s" [loading]="true">Тест</button>&ndash;&gt;-->
<!--    <button pButton class="p-button-gpl p-button-gpl-text">Тест текст</button>-->
<!--&lt;!&ndash;    <button pButton class="p-button-gpl p-button-gpl-text" [loading]="true">Только текст</button>&ndash;&gt;-->
<!--  </div>-->
</div>
